import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const OptionPicker: StyleRule<{ expanded: boolean }> = ({
    theme,
    expanded,
}) => ({
    fontSize: theme.siteVariables.fontSizes['caption03'],
    color: theme.siteVariables.colors.grey['300'],
    justifyContent: 'flex-start',
    paddingBottom: pxToRem(expanded ? 3 : 20),
});

export const SubTitle: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.charcoal['000'],
    fontSize: pxToRem(16),
    whiteSpace: 'pre-wrap',
    maxWidth: pxToRem(346),
    lineHeight: pxToRem(16),
});
